import React from 'react';

const PhoneNumber = (props) => {
    return (<>
        <a className='link-external hide-on-desktop' href={`tel:${props.value || props.label.replace(/ /g, '-')}`}>{props.label}</a>
        <span className='hide-on-mobile'>{props.label}</span>
    </>);
}

export default PhoneNumber;